<template>
  <div>
    <span class="pl-0 fadeW" v-if="!loading">
      <!-- componente Descricao -->
      <b>{{ dados.ncm }}</b>
      {{ dados.descricao }}
    </span>
    <div class="text-center" v-else>
      <div class="spinner-border text-primary text-center" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dados: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      numNCM: this.$route.params.ncm,
      usuario: ""
    };
  }
};
</script>

<style scoped>
</style>